/* import __COLOCATED_TEMPLATE__ from './react-wormhole.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import { registerDestructor } from '@ember/destroyable';

interface Signature {
  Args: {
    identifier: string;
  };
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}

export default class ReactWormhole extends Component<Signature> {
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;

  @tracked mountingPoint: HTMLElement | null = null;

  get styleSheetsUrls(): string[] {
    return Array.from(document.styleSheets)
      .filter((s) => !!s.href)
      .map((s) => s.href as string);
  }

  findMountingPoint: (payload: any) => void = () => {
    let teammateAppElement = document.querySelector('#teammate-app-react');
    if (teammateAppElement && teammateAppElement.shadowRoot) {
      let mountingPointShadow = teammateAppElement.shadowRoot.getElementById(
        this.args.identifier,
      ) as HTMLElement;

      if (mountingPointShadow && mountingPointShadow.shadowRoot) {
        this.mountingPoint = mountingPointShadow.shadowRoot.querySelector(
          '[data-shadow-container]',
        ) as HTMLElement;
      }
    }
  };

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);

    this.reactTeammateAppIsland.subscribeToMountingEvent(
      this.args.identifier,
      this.findMountingPoint,
    );

    this.findMountingPoint({});

    registerDestructor(this, () => {
      this.reactTeammateAppIsland.unsubscribeFromMountingEvent(
        this.args.identifier,
        this.findMountingPoint,
      );
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    ReactWormhole: typeof ReactWormhole;
    'react-wormhole': typeof ReactWormhole;
  }
}
